// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"bb990da5","252":"b9012141"}[chunkId] + ".chunk.css";
};